module.exports = __webpack_public_path__ + "img/49.664a6844.png";